import { mapDTO } from '@twistezo/ts-dto-mapper'

import { defaultOptionStates } from 'components/Form/CheckboxTreeFilterable'
import { biddersFromDTO } from './biddersFromDTO'
import { prebidModuleFromDTO } from './prebidModuleFromDTO'
import { recursivelyAddDefaultOptionStates } from './recursivelyAddDefaultOptionStates'

import type { AbTestsParametersSchemaDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'
import type { AbTestParametersSchema } from 'features/ab-tests/types/abTestParametersSchema'

type From = AbTestsParametersSchemaDTO
type To = AbTestParametersSchema

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((schemaDTO: From): To => {
    const {
      general,
      prebidStack: prebidStackDTO,
      refresher,
      unfilledRecovery: unfilledRecoveryDTO,
      viewabilityTools,
    } = schemaDTO

    const prebidModules: AbTestParametersSchema['prebidStack']['prebidModules'] = {
      analytics: prebidModuleFromDTO(prebidStackDTO.prebidModules.analytics),
      general: prebidModuleFromDTO(prebidStackDTO.prebidModules.general),
      label: prebidStackDTO.prebidModules.label,
      userId: prebidModuleFromDTO(prebidStackDTO.prebidModules.userId),
      vendorSpecific: prebidModuleFromDTO(prebidStackDTO.prebidModules.vendorSpecific),
    }

    const prebidStack: AbTestParametersSchema['prebidStack'] = {
      ...prebidStackDTO,
      bidders: {
        ...biddersFromDTO(prebidStackDTO.bidders.items),
        label: prebidStackDTO.bidders.label,
      },
      prebidModules,
    }

    const { label, prebidBehaviourType, unfilledRecoveryEnabled } = unfilledRecoveryDTO
    const unfilledRecovery: AbTestParametersSchema['unfilledRecovery'] = {
      label,
      unfilledRecoveryEnabled,
      ...(prebidBehaviourType ? { prebidBehaviourType } : {}),
    }

    return recursivelyAddDefaultOptionStates(
      {
        general,
        prebidStack,
        refresher,
        unfilledRecovery,
        viewabilityTools,
      },
      defaultOptionStates,
    ) as AbTestParametersSchema
  })
